<template>
  <el-dialog :visible.sync="domVisible" :custom-class="dialogClass" :lock-scroll="false" :before-close="handleClose">
    <template slot="title">
      <span class="el-dialog__title">{{title}}
      </span>
    </template>
    <div id="dialogBoxWare" class="dialogData">
      <ul class="orderStateDetail">
        <li><span class="text_gray">{{list.Details.length != 1? $t('base.items') :$t('base.item') }} ({{list.Details.length}}):</span>{{orderCheckList.areaSymbol}} {{list.USD_TotalPrice||list.subtotal}}</li>
        <li><span class="text_gray">{{ $t('base.shippingTo') }} {{orderCheckList.shipping}}:</span>{{orderCheckList.postPrice>0?orderCheckList.areaSymbol+' '+orderCheckList.postPrice:orderCheckList.postageMoney}}</li>
        <li v-if="orderCheckList.ServiceFee"><span class="text_gray">{{ $t('base.buyerPermium') }}:</span>{{orderCheckList.areaSymbol}} {{orderCheckList.ServiceFee}}</li>
        <li v-if="orderCheckList.TaxServiceFee"><span class="text_gray">{{ $t('base.stateTax') }}:</span>{{orderCheckList.areaSymbol}} {{orderCheckList.TaxServiceFee}}</li>
        <li><span class="text_gray">{{ $t('base.orderTotal') }}:</span>{{orderCheckList.areaSymbol}} {{orderCheckList.totalPrice}}</li>
      </ul>
      <div class="orderListBox">
        <div class="orderList orderListTop">
          <div class="commodity">{{$t('base.commodityTitle')}}</div>
          <div class="quantity" v-if="orderCheckList.type=='store'">{{$t('base.quantity')}}</div>
          <div class="operate">{{ $t('base.itemPrice') }}</div>
        </div>
        <el-scrollbar>
          <ul class="orderScrollbar">
            <li class="orderList" v-for="(item,index) in list.Details" :key="index">
              <div class="commodity">
                <el-image class="like_img" :src="orderCheckList.type=='store'?item.Imgs[0]:item.TitImg" fit="contain"></el-image>
                <p class="line_txt4"><span class="line_txt4">{{item.Title}}</span>
                      <span class="ConditionName" v-if="orderCheckList.type=='store'">{{item.ConditionName}}</span></p>
              </div>
              <div class="quantity" v-if="orderCheckList.type=='store'">{{item.Quantity}}</div>
              <div class="operate">{{item.Currency||orderCheckList.areaSymbol}} {{item.USD_Price||item.NewPrice}}</div>
            </li>
          </ul>
        </el-scrollbar>
        <div class="footer">
          <el-button class="base" @click="handleClose">{{$t('base.back')}}</el-button>
          <el-button class="base" type="primary" @click="confirmOrder">{{$t('base.pay')}}</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { getTime } from "@/api/public";
import NOTN from "@/components/notnull.vue";
export default {
  name: 'ordercheck',
  components: { NOTN },
  data() {
    return {}
  },
  props: {
    dialogClass: '',
    title: '',
    orderCheckList: {},
    domVisible: Boolean,
    list: {},
    userInfo: {}
  },
  watch: {},
  filters: {},
  created() {},
  methods: {
    handleClose() {
      this.$emit('closeDialog', 'ordercheck', false)
    },
    confirmOrder() {
      this.$emit('addOrder')
    }
  },
  //离开页面后
  destroyed() {
    this.handleClose()
    //alert(2);
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#dialogBoxWare {
  min-height: 400px;
  max-height: 80vh;
}

.orderList {
  display: flex;
  border-bottom: 1px solid #e0e0e0;
}

.orderListTop {
  background-color: #f7f7f7;
}

.orderList>div {
  width: 70%;
  padding: 16px 12px;
  color: #333;
  box-sizing: border-box;
}

.orderList>div.commodity {
  display: flex;
}
.orderList>div.quantity {
  width: 15%;
}
.orderList>div.operate {
  width: 15%;
}

.commodity p {
  width: 70%;
}


.like_img {
  width: 88px;
  height: 88px;
  display: block;
  margin-right: 12px;
      background-color: #f7f7f7;
}

.orderStateDetail li {
  margin-bottom: 16px;
}

.orderStateDetail li span {
  margin-right: 8px;
}

.orderScrollbar {
  height: 125px;
}

/deep/ .base {
  padding: 9px 12px;
}

.footer {
  text-align: right;
  margin-top: 22px;
}
.ConditionName {
  border-radius: 2px;
  padding: 4px 12px;
  color: #a0a0a0;
  background: #f7f7f7;
  display: inline-block !important;
  margin-top: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/ordercheck.vue